import React from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';
import { Typography, Button, Colors } from '@utex/ui-kit';
import { BaseModal } from './Base';
import { MoneyView } from '../MoneyView';
import { useConversionService } from '../../hooks/useConversionService';
import { useHandlers } from '../../hooks/useHandlers';

export const SuccessModal: React.FC = observer(() => {
  const { t } = useTranslation('success');
  const { goToInvestment } = useHandlers();
  const { amountFrom, amountTo } = useConversionService();

  return (
    <BaseModal
      icon="success"
      testId="conversion-success-modal"
      title={t('Success Title')}
      footer={
        <Button isLong={true} view="regular-shadow" onClick={goToInvestment}>
          {t('Success Button Text')}
        </Button>
      }
      backgroungColor={Colors.ut.successDim}
    >
      {amountFrom && amountTo && (
        <>
          <Typography.Text>
            {t('Debited from the account')} <MoneyView>{amountFrom}</MoneyView>
          </Typography.Text>
          <br />
          <Typography.Text>
            {t('Credited to the account')} <MoneyView>{amountTo}</MoneyView>
          </Typography.Text>
        </>
      )}
    </BaseModal>
  );
});
